import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/ninjaz-landing/ninjaz-landing/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ninjaz-landing/ninjaz-landing/src/app/_components/Shared/DeleteForm/index.js");
